import React from 'react';
import ContactForm from '../forms/ContactForm';

const ContactPage = () => {
    return (
        <div>
            <ContactForm />
        </div>
    );
};

export default ContactPage;

